import algoliasearch from "algoliasearch";
import { AlgoliaFinishHit } from "../types/AlgoliaTypes";
import { algoliaConfig } from "../data/config";

const searchClient = algoliasearch("BCXURW325T", "f9ee2c1748b8d3914488faf0da618532");
const index = searchClient.initIndex(algoliaConfig.MATERIAL_INDEX)

export async function getObject(objectID: string): Promise<AlgoliaFinishHit> { 
    try { 
        const obj = await index.getObject(objectID); 
        return obj as AlgoliaFinishHit; 
    } catch (err) { 
        throw new Error(); 
    } 
}

export async function getFeaturedMaterials(category: string) {
    try {
        const values = await index.search('', {
            filters: `category.code:${category} AND featuredOrder.isFilterable:true`
        })
        
        return values;
    } catch (err) {
        console.log(err)
        throw new Error();
    }
}

export async function getMaterials() {
    try {
        const values = await index.search('', {
            // filters: 'featured_order != null'
        })
        
        return values;
    } catch (err) {
        console.log(err)
        throw new Error();
    }
}

export async function getFinishByRouterValue(routerValue: string): Promise<AlgoliaFinishHit>{
    try {
        const obj = await index.search(routerValue)
        return obj.hits[0] as AlgoliaFinishHit;
    } catch (err) {
        console.log(err)
        throw new Error();
    }
}

export async function getSubcategories(categoryCode: string): Promise<Record<string, Record<string, number>> | undefined> {
    try {
        const reqOpts = {facets: ['filters.subcategory'], filters: ``}
        if(categoryCode.length > 0) {
            reqOpts.filters = `category.code:${categoryCode}`
        }
        const values = await index.search("", reqOpts)
        return values.facets;
    } catch (err) {
        console.log(err)
    }
}

export async function getCategories(categoryCode?: string): Promise<Record<string, Record<string, number>> | undefined> {
    try {
        const reqOpts = { facets: ['category.label'], filters: `` }
        if(categoryCode && categoryCode.length > 0) {
            reqOpts.filters = `category.code:${categoryCode}`
        }
        const values = await index.search("", reqOpts)
        return values.facets;
    } catch (err) {
        console.log(err)
    }
}